import styled from "styled-components";
import PROFILE_SVG from "assets/images/profile.svg";
import InputWithLabel from "shared/components/InputWithLabel";
import InputWithDuplicateCheck from "shared/components/InputWithDuplicateCheck";
import Permission from "shared/components/Permission";
import { hw } from "features/homework/homeworkUi";

interface StudentInputsProps {
    studentInputs: {
        name: string;
        tel: string;
        id: string;
        pw: string;
        pw_re: string;
        join_date: string;
        school: string;
        birth: string;
        shuttle: boolean;
        level: string;
        fee: string;
    };
    onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
    setIsDuplicated: React.Dispatch<React.SetStateAction<any>>;
}

const StudentInputs = ({ studentInputs, onChange, setIsDuplicated }: StudentInputsProps) => {
    return (
        <Container>
            <Head>
                <ProfileImg src={PROFILE_SVG} alt="" />
                <div>
                    <Title>필수 입력</Title>
                    <Hint>비밀번호에는 영문과 숫자가 모두 들어가야 합니다.</Hint>
                </div>
            </Head>
            <Inputs>
                <InputWithLabel required={true} label="학생이름" name="name" value={studentInputs.name} onChange={onChange} />
                <InputWithDuplicateCheck setIsDuplicated={setIsDuplicated} required={true} label="아이디" name="id" value={studentInputs.id} onChange={onChange} table="User/Auth/Log" field="id" />
                <InputWithLabel required={true} label="비밀번호" name="pw" value={studentInputs.pw} onChange={onChange} />
                <InputWithLabel required={true} label="비밀번호 재입력" name="pw_re" value={studentInputs.pw_re} onChange={onChange} />
                <InputWithLabel required={true} label="등록일" name="join_date" value={studentInputs.join_date} onChange={onChange} placeholder="ex) 0000-00-00" />
                <InputWithLabel label="학교" name="school" value={studentInputs.school} onChange={onChange} />
                <InputWithLabel label="생년월일" name="birth" value={studentInputs.birth} onChange={onChange} placeholder="ex) 0000-00-00" />
                <InputWithLabel label="레벨" name="level" value={studentInputs.level} onChange={onChange} />
                <InputWithLabel label="수업료" name="fee" value={studentInputs.fee} onChange={onChange} />
                <PermissionWrap>
                    <Permission label="셔틀 버스 이용" name="shuttle" defaultChecked={studentInputs.shuttle} onChange={onChange} />
                </PermissionWrap>
            </Inputs>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: ${hw.bg};
    padding: 20px 22px;
    border-radius: 14px;
    border: 1px solid ${hw.border};
`;

const Head = styled.div`
    display: flex;
    align-items: center;
    gap: 16px;
`;

const ProfileImg = styled.img`
    width: 56px;
    height: 56px;
    object-fit: contain;
`;

const Title = styled.h2`
    margin: 0;
    color: ${hw.text};
    font-size: 16px;
    font-weight: 700;
    letter-spacing: -0.02em;
`;

const Hint = styled.p`
    margin: 4px 0 0;
    font-size: 12px;
    color: ${hw.textMuted};
`;

const Inputs = styled.div`
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 16px 20px;

    @media (max-width: 800px) {
        grid-template-columns: 1fr;
    }
`;

const PermissionWrap = styled.div`
    display: flex;
    align-items: flex-end;
    padding-bottom: 4px;
`;

export default StudentInputs;
